import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "antd/lib/mention/style/css";
import _Mention from "antd/lib/mention";
import * as tslib_1 from "tslib";
import { Field } from "formik";
import * as React from "react";
var toContentState = _Mention.toContentState,
    toString = _Mention.toString;
export var Mention = function Mention(_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref) {
    var value = _ref.field.value,
        _ref$form = _ref.form,
        setFieldValue = _ref$form.setFieldValue,
        setFieldTouched = _ref$form.setFieldTouched;
    return React.createElement(Internal, Object.assign({
      name: name,
      value: value,
      onChange: function onChange(v) {
        return setFieldValue(name, v);
      },
      onBlur: function onBlur() {
        return setFieldTouched(name);
      }
    }, restProps));
  });
};

var Internal = function Internal(_a) {
  var value = _a.value,
      _onChange = _a.onChange,
      onBlur = _a.onBlur,
      restProps = tslib_1.__rest(_a, ["value", "onChange", "onBlur"]);

  var _React$useState = React.useState(toContentState(value || "")),
      editorState = _React$useState[0],
      setEditorState = _React$useState[1];

  return React.createElement(_Mention, Object.assign({
    value: editorState,
    onChange: function onChange(v) {
      setEditorState(v);

      _onChange(toString(v));
    }
  }, restProps));
};